<app-header (clearExam)="clearRadioButtons()"></app-header>
<div class="content big-head">
  <form [formGroup]="examForm" (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined" class="max-content-card">
      <mat-card-content class="card-footer" class="kbw-exam">
        @if (isLoadnig) {
          <mat-progress-spinner
            class="spinner-margin"
            color="accent"
            mode="indeterminate"
            diameter="100"
            value="50">
          </mat-progress-spinner>
        }
        <div formArrayName="examModel">
          <ol [className]="isMobile ? 'exam-qa-mobile' : 'exam-qa'">
            @for (exam of examForm.get('examModel')['controls']; track exam; let examIndex = $index) {
              <li  [formGroupName]="examIndex">
                <!-- <li  *ngFor="let exam of examForm.get('examModel').controls; let examIndex = index" [formGroupName]="examIndex"> -->
                <input type="hidden" formControlName="questionId">
                <b><div [innerHTML]="exam.get('questionTranslatedText').value"></div></b>
                <mat-radio-group class="default-radio-group" id="ExamQAGroup" formControlName="selectedAnswer" color="primary">
                  <div formArrayName="answersForQuestion">
                    @for (answers of exam.get('answersForQuestion')['controls']; track answers; let i = $index) {
                      <mat-radio-button class="default-radio-button" (change)="onChange($event)" [formGroupName]="i" [value]="answers.get('id').value">
                        <div class="label-no-wrap" [innerHTML]="answers.get('translatedText').value"></div>
                      </mat-radio-button>
                    }
                  </div>
                </mat-radio-group>
              </li>
            }
          </ol>

        </div>
      </mat-card-content>
      <mat-card-actions align="right" class="card-footer">
        <button mat-raised-button color="primary" type="submit" [disabled]="isLoadnig">{{'FinishExam' | translate }}</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>